import { useContext, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { cn } from '@/lib/utils';
import { AppHeaderTitleSlotContext } from './appHeaderTitleSlot';

interface PageTitleProps {
  children: ReactNode;
  leading?: ReactNode;
  titleAddon?: ReactNode;
  className?: string;
}

export function PageTitle({ children, leading, titleAddon, className }: PageTitleProps) {
  const titleSlot = useContext(AppHeaderTitleSlotContext);

  const titleBlock = (
    <div className="flex min-w-0 items-center gap-3">
      {leading}
      <div className="flex min-w-0 flex-col gap-0.5 sm:flex-row sm:items-center sm:gap-3">
        <h1
          className={cn(
            'truncate text-xl leading-tight font-semibold tracking-tight sm:text-2xl',
            className,
          )}
        >
          {children}
        </h1>
        {titleAddon}
      </div>
    </div>
  );

  if (titleSlot === null) return titleBlock;
  return createPortal(titleBlock, titleSlot);
}
